/**
 * documentCompanyRenderer — WSPÓLNY renderer pola core `company_id` dla 7 klas dokumentów.
 *
 * Firmę dokumentu wybiera się PRZED założeniem (picker typu / URL) i potem się jej nie zmienia,
 * więc w formularzu pole jest zawsze tylko do odczytu: nazwa firmy z listy firm tenanta
 * (`useCompanies`), po `ctx.companyId` (firma rekordu albo — w create — firma z URL-a). Mirror
 * zachowania „Firma" u kontrahenta/pracownika po utworzeniu (zablokowany picker).
 *
 * Pole jest OPT-IN: configi dokładają je do mapy `fields`, ale NIE do `coreFieldSlugs` — formularz
 * domyślny (synteza zakładki „Dane") się nie zmienia; „Firma" pojawia się tylko, gdy projektant
 * wstawi ją do układu (dotąd taki układ dawał bursztynowe „Typ pola nie jest obsługiwany").
 */

import { Field } from '@/components/kartoteki/CoreFieldLayout';
import type { CoreFieldConfig, FieldRenderer } from '@/components/kartoteki/engine/engine-config';
import { useCompanies } from '@/lib/use-permissions';

import { TextInput } from './documentCoreRenderers';

export function DocumentCompanyField({
  companyId,
  label,
  testId,
}: {
  companyId: string | null | undefined;
  label: string;
  testId: string;
}) {
  const companiesQ = useCompanies();
  const company = companyId
    ? companiesQ.data?.companies.find((c) => c.id === companyId)
    : undefined;
  const value = company ? (company.shortName ?? company.legalName) : '';
  return (
    <Field label={label}>
      <TextInput testId={testId} value={value} onChange={() => {}} disabled />
    </Field>
  );
}

export function makeDocumentCompanyRenderer<TForm, TExtra = undefined>(): FieldRenderer<
  TForm,
  TExtra
> {
  return (ctx) => (
    <DocumentCompanyField
      companyId={ctx.companyId}
      label={ctx.field.name}
      testId={`${ctx.testIdPrefix}-companyId`}
    />
  );
}

/** Wpis `company_id` do mapy `fields` configu silnika (bez `stateKey` — pole nie należy do formularza). */
export function documentCompanyFieldConfig<TForm, TExtra = undefined>(): CoreFieldConfig<
  TForm,
  TExtra
> {
  return { fieldType: 'reference', renderer: makeDocumentCompanyRenderer<TForm, TExtra>() };
}
